import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// ── PWA : capture globale du prompt d'installation (avant le montage React) ──
window.__pwaPrompt = null;
window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  window.__pwaPrompt = e;
  window.dispatchEvent(new Event("pwa-prompt-ready"));
});

// Manifest contextuel : back-office vs boutique client
const manifestLink = document.querySelector('link[rel="manifest"]');
if (manifestLink && !window.location.pathname.startsWith("/admin")) {
  manifestLink.href = "/manifest-store.json";
}

// Service worker enregistré partout (requis pour installation + notifications push)
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.register("/sw.js").catch(() => {});
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
